"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aicurzio": {
    "9b3168f8": [{
      "hkey": "b3535d21",
      "slug": "commenda-castel-negrino",
      "name": "Commenda-Castel Negrino",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-castel-negrino": [{
      "hkey": "b3535d21",
      "slug": "commenda-castel-negrino",
      "name": "Commenda-Castel Negrino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "aicurzio"
    }],
    "d6c436a4": [{
      "hkey": "b3535d21",
      "slug": "commenda-castel-negrino",
      "name": "Commenda-Castel Negrino",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-commenda": [{
      "hkey": "b3535d21",
      "slug": "commenda-castel-negrino",
      "name": "Commenda-Castel Negrino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "aicurzio"
    }],
    "ac19ee12": [{
      "hkey": "c1f72982",
      "slug": "aicurzio",
      "name": "Aicurzio",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-morosina": [{
      "hkey": "c1f72982",
      "slug": "aicurzio",
      "name": "Aicurzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8018b92": [{
      "hkey": "c1f72982",
      "slug": "aicurzio",
      "name": "Aicurzio",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-restelli": [{
      "hkey": "c1f72982",
      "slug": "aicurzio",
      "name": "Aicurzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;